module.exports = __webpack_public_path__ + "static/media/USS.42dce613.svg";